import { render, staticRenderFns } from "./analyze.vue?vue&type=template&id=80d6aa4a&scoped=true&"
import script from "./analyze.vue?vue&type=script&lang=js&"
export * from "./analyze.vue?vue&type=script&lang=js&"
import style0 from "./analyze.vue?vue&type=style&index=0&id=80d6aa4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d6aa4a",
  null
  
)

export default component.exports